import { axiosSW, axiosSW2 } from "../../api/axiosDefaults";

/**
 * Fetch the searched ticket and related tickets, if available
 * @param {Object} userInput - the object that contains the user data input from the search form
 */
export const fetchTickets = async (
    userInput,
    {
        setIsLoading,
        setResponseData,
        setResult,
        setIsValidSearch,
        setCurrentTicket,
        setTicketType,
        setCurrentCategory,
        navigate,
        handleError,
        homePath,
    },
) => {
    /**
     * check if the user input object is valid by checking if it has the required properties
     * @param {Object} obj the user Input object
     * @returns {Boolean} true if the object is valid, false otherwise
     */
    const validateUserInput = () => {
        return (
            userInput?.customerId &&
            userInput?.ticketNumber &&
            (userInput?.plate || userInput?.issueDate)
        );
    };

    setIsLoading(true);
    setResponseData(null);
    setResult(null);
    try {
        if (validateUserInput()) {
            const { data } = await axiosSW2.post("Tickets/search", userInput);

            setResponseData(data);

            if (data) {
                switch (data?.outputStatus) {
                    case 1:
                    case 2:
                    case 3:
                    case 5:
                    case 6:
                    case 8:
                    case 9:
                        setResult(data);
                        navigate(`${homePath}/result`);
                        setIsLoading(false);
                        break;

                    case 4:
                        setIsValidSearch(true);
                        setCurrentTicket(data?.ticket);
                        setTicketType(0);
                        setCurrentCategory(data?.ticket?.photos?.[0]?.category);
                        navigate(`${homePath}/search`);
                        setIsLoading(false);
                        break;
                    case 7:
                        setIsValidSearch(true);
                        setTicketType(1);
                        setCurrentTicket(data?.settlements?.[0]);

                        setCurrentCategory(
                            data?.relatedTickets?.[0]?.photos?.[0]?.category,
                        );
                        navigate(`${homePath}/search`);
                        setIsLoading(false);
                        break;

                    default:
                        setIsLoading(false);
                        handleError({
                            error: data,
                            errorMessage: "Bad response",
                        });
                }
            } else {
                setIsLoading(false);
                handleError({
                    error: data,
                    errorMessage: "No data",
                });
            }
            //  Set error to userInput and call the error handler if data is not available
        } else {
            setIsLoading(false);
            handleError({
                error: userInput,
                errorMessage: "user input not valid",
            });
        }
    } catch (error) {
        setIsLoading(false);
        handleError(error);
    }
};
